export function useTheme() {
  const chatNavHeadHeight = 50

  return {
    chatNavHeadHeight,
  }
}
